import * as React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { filter } from 'lodash';
import routes, { routeFor } from 'helpers/routes';
// import { BlogType, BlogCategoryType } from 'types';
import Link from 'gatsby-link';
import { theme, media } from 'styles';
import { Breadcrumbs, Container, Button, SeoTags } from 'components/shared';
import { Sidebar, List } from './components';

const Wrapper = styled.div`
  background-color: ${theme.colors.offWhite};
  background-position: top 0px right 0px;
  padding-bottom: 36px;

  ${media.laptop`
    padding-bottom: 96px;
  `};
`;

const HeroButton = styled(Button)``;

const Hero = styled.div`
  margin-bottom: 40px;

  ${media.tablet`
    display: flex;
    margin-bottom: 100px;
    height: 600px;
  `};

  h2 {
    padding: 30px 0;
    font-size: 24px;
    line-height: 36px;
    font-weight: 500;

    ${media.tablet`
      font-size: 32px;
      line-height: 48px;
    `};

    ${media.laptop`
      padding: 50px 0 60px;
      font-size: 48px;
      line-height: 58px;
    `};
  }
`;

const HeroContent = styled.div`
  display: block;
  background-color: ${theme.colors.white};
  padding: 40px 30px;
  width: 100%;

  ${media.tablet`
    padding: 80px 100px;
    width: 45%;
  `};
`;

const HeroImageLink = styled(Link)`
  width: 100%;
  height: 300px;

  ${media.tablet`
    width: 55%;
    height: auto;
  `};
`;

const HeroImage = styled.div`
  background-size: cover;
  background-position: center top;
  background-image: url('${props => props.src}');
  background-repeat: no-repeat;
  width: 100%;
  height: 300px;

  ${media.tablet`
    height: 100%;
  `};
`;

const Main = styled(Container)`
  display: flex;
  flex-direction: column;

  ${media.desktop`
    flex-direction: row;
  `};
`;

const propTypes = {
  posts: PropTypes.arrayOf({}).isRequired,
  postCategories: PropTypes.arrayOf({}).isRequired,
  selectedCategoryId: PropTypes.string,
  seoTitle: PropTypes.string,
  seoKeywords: PropTypes.string,
  seoDescription: PropTypes.shape({}),
};

// The weirdo definition of the seoDescription is necessary to mimic the way
// the data comes from Contentful (for post categories)
const defaultProps = {
  selectedCategoryId: undefined,
  seoTitle: "Digital Marketing Trends & More | Tap'd In",
  seoKeywords: undefined,
  seoDescription: {
    seoDescription:
      "Stay on top of the latest digital marketing trends as they happen with our Tap'd In blog. Topics include SEO, Lead Generation, Social Media, Strategy and more! Get Tap'd In today.",
  },
};

class BlogsPage extends React.Component {
  state = {
    selectedCategoryId: this.props.selectedCategoryId,
    searchTerm: '',
    seoTitle: this.props.seoTitle,
    seoKeywords: this.props.seoKeywords,
    seoDescription: this.props.seoDescription,
  };

  getBreadcrumbs = () => {
    const initial = [
      {
        name: 'Home',
        link: `${routes.home.index}`,
      },
      {
        name: 'Tapd in',
        link: `${routes.blog.index}`,
      },
    ];

    return initial;
  };

  getPosts = () => {
    const { posts } = this.props;
    const { searchTerm } = this.state;
    const filteredPosts = filter(posts, post =>
      post.heading.toLowerCase().includes(searchTerm.toLowerCase()),
    );
    return filteredPosts;
  };

  updateSearch = ({ target }) => {
    this.setState({ searchTerm: target.value });
  };

  selectCategory = args => {
    const { id, slug } = args;
    const selectedCategory =
      filter(this.props.postCategories, category => category.id === id)[0] ||
      {};
    this.setState({
      selectedCategoryId: id,
      seoTitle: selectedCategory.seoTitle,
      seoKeywords: selectedCategory.seoKeywords,
      seoDescription: selectedCategory.seoDescription,
    });
    if (window.history && window.history.pushState) {
      const url = slug
        ? routeFor(routes.blog.category, slug)
        : routes.blog.index;
      window.history.pushState({ selectedCategoryId: id }, '', url);
    }
  };

  render() {
    const { postCategories } = this.props;
    const {
      selectedCategoryId,
      searchTerm,
      seoTitle,
      seoKeywords,
      seoDescription,
    } = this.state;
    const posts = this.getPosts();
    const breadcrumbs = this.getBreadcrumbs();
    const firstPost = posts[0];

    return (
      <Wrapper>
        <SeoTags
          title={seoTitle}
          keywords={seoKeywords}
          description={seoDescription && seoDescription.seoDescription}
        />

        <Hero>
          <HeroContent>
            <Breadcrumbs left breadcrumbs={breadcrumbs} />
            <h2>{firstPost.heading}</h2>
            <HeroButton blue to={`/tapd-in/${firstPost.slug}`}>
              Learn More
            </HeroButton>
          </HeroContent>
          <HeroImageLink to={`/tapd-in/${firstPost.slug}`}>
            <HeroImage
              src={firstPost.headerBackgroundImage.responsiveResolution.src}
              alt={firstPost.heading}
            />
          </HeroImageLink>
        </Hero>

        <Main>
          <Sidebar
            selectCategory={this.selectCategory}
            postCategories={postCategories}
            selectedCategoryId={selectedCategoryId}
            searchTerm={searchTerm}
            updateSearch={this.updateSearch}
          />
          <List posts={posts} selectedCategoryId={selectedCategoryId} />
        </Main>
      </Wrapper>
    );
  }
}

BlogsPage.propTypes = propTypes;
BlogsPage.defaultProps = defaultProps;

export default BlogsPage;



// WEBPACK FOOTER //
// ./src/components/BlogsPage/BlogsPage.jsx